export default __webpack_public_path__ + "static/media/a93aa6d7017acdd8895f6b4b291731be.svg";